<div class="content-div">
  <div class="info-bar">
    <app-breadcrumbs [breadcrumbs]="BreadcrumbsLink"></app-breadcrumbs>
    <app-basic-button id="help-btn-wallboard" type="secondary" isIcon="true" size="medium" (click)="openHelp()">
      <i class="fal far fa-info-circle fs-16"></i>
    </app-basic-button>
  </div>
  <div class="top-bar">
    <span class="page-header">
      {{ 'realtime:RealtimeWallboard' | i18next }}
    </span>

    <div class="wallboard-controls right">
      <div>

      </div>
      <div *ngIf="enableImpersonation" class="impersonation-controls">
      <div>
          Act as...
      </div>
      <div>
      <div class="toggleButtons">
        <app-basic-button id="impersonate-yourself-btn-wallboard" [type]="!impersonationActive ? 'primary' : 'secondary'" [text]="'realtime:Yourself' | i18next" fontSize="12px"
        size="small" (click)="cancelImpersonation()" [dropShadow]="false"></app-basic-button>
        <app-basic-button id="impersonate-user-btn-wallboard" [type]="impersonationActive ? 'primary' : 'secondary'" [text]="'realtime:User' | i18next" fontSize="12px"
        size="small" [dropShadow]="false" disableHoverEffect="true"></app-basic-button>
      </div>
        <app-basic-dropdown id="impersonate-user-dropdown-wallboard" size="medium" [(model)]="selectedImpersonateUser" [items]="impersonateUsers"
          (modelChange)="switchImpersonation($event)" bindLabel="name" bindValue="id"
          placeholder="{{ 'realtime:SelectImpersonateUser' | i18next }}" [clearable]="false"></app-basic-dropdown>
      </div>
      </div>
      <app-basic-button id="settings-btn-wallboard" *ngIf="displaySettingsButton" type="secondary" size="medium" (click)="goToSettings()">
        <i class="far fa-cog fs-16"></i> {{'realtime:wallboard_Settings' | i18next }}</app-basic-button>
      <app-basic-button id="fullscreen-btn-wallboard" type="primary" size="medium" (click)="toggleFullscreen()">{{ 'realtime:wallboard_FullScreen' |
        i18next }}</app-basic-button>
    </div>
  </div>
  <div class="content">
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
    <!-- Error Pane -->
    <div class="error-pane" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>
    <div>
      <span *ngIf='(wallboardResponseType == "Queue")'
        class="wallboard-type-indicator">
        {{'realtime:Queues' | i18next }}
      </span>
      <span *ngIf='!(wallboardResponseType == "Queue")'
        class="wallboard-type-indicator">
        {{'realtime:Agents' | i18next }}
      </span>
      <span class="wallboard-pagination">
        {{ paginationText() }}
      </span>
    </div>
    <!-- Wallboard Container -->
    <div class="wallboard-container" [class.fullscreen]="isFullscreen"
      [style.font-family]="wallboardData?.settings?.fontFamily || 'Arial, sans-serif'" (click)="refreshWallboard()">

      <div class="fullscreen-header" *ngIf="isFullscreen">
        <img *ngIf="wallboardData?.settings?.logoUrl" [src]="wallboardData.settings.logoUrl" alt="Logo"
          class="wallboard-logo" />
        <span *ngIf='wallboardResponseType == "Queue"'
          class="fullscreen-title">
          {{'realtime:Queues' | i18next }}
        </span>
        <span *ngIf='wallboardResponseType != "Queue"'
          class="fullscreen-title">
          {{'realtime:Agents' | i18next }}
        </span>
        <div class="right">
          <span class="wallboard-pagination">
          {{ paginationText() }}
        </span>
        <app-basic-button id="exit-fullscreen-btn-wallboard" isIcon="true" size="medium" (click)="toggleFullscreen()" size="medium">
          <i class="fal fa-times fs-16"></i>
        </app-basic-button>
        </div>
      </div>
      <table class="wallboard-table" id="wallboardTable" *ngIf="!isSingleItemView() && displayItems?.length > 0">
        <thead id="wallboardHeader">
          <tr>
            <th [style.color]="wallboardData?.settings?.txtColor || '#cbcbcb'"
              [style.background-color]="wallboardData?.settings?.bgColor || '#2C2C2C'" >
              {{ wallboardResponseType == "Queue" ? ( 'realtime:queue' | i18next ) : ( 'realtime:agent' | i18next ) }}
            </th>
            <th *ngFor="let column of displayColumns || []"
              [style.color]="wallboardData?.settings?.txtColor || '#cbcbcb'"
              [style.background-color]="wallboardData?.settings?.bgColor || '#2C2C2C'" >
              <span >{{column | htmlDecode }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <!-- Unified Wallboard Items -->
          <tr *ngFor="let item of displayItems || []; let i = index" [class.alarm-row]="item.isAlarm">
            <td [class]="item.type === 'queue' ? 'queue-name' : 'agent-name'" class="first-column">
              <span >{{truncateText(item.name, 25) | htmlDecode }}</span>
            </td>
            <td *ngFor="let value of item.values || []; let j = index" class="values value-column"
              [class.value-red]="item.valueColors && item.valueColors[j] == 1"
              [class.left]="wallboardData?.agentColumns && textColumns.includes(wallboardData.agentColumns[j])"
              >
              <span >{{ value || '-' | htmlDecode }}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- Single Item Wallboard View -->
      <table class="wallboard-table" id="wallboardTable" *ngIf="isSingleItemView()">
        @let item = displayItems[0];
        <thead id="wallboardHeader">
          <tr>
            <th colspan="3" [style.color]="wallboardData?.settings?.txtColor || '#cbcbcb'"
              [style.background-color]="wallboardData?.settings?.bgColor || '#2C2C2C'">
              <span >{{item.name | htmlDecode }}</span>
            </th>
        </thead>
        <tbody>
          <!-- Unified Wallboard Items -->
          <tr [class.alarm-row]="item.isAlarm">
            <ng-container *ngFor="let value of item.values || []; let j = index">
              @let column = (displayColumns || [])[j];
              @if (j<3 && column){ <td class="values-single" >
                <span class="values-single" >{{column | htmlDecode }}</span><br /><br />
                <span class="values-single" [class.value-red]="item.valueColors && item.valueColors[j] == 1"
                  >{{ value || '-' | htmlDecode }}</span>
                </td>
                }
            </ng-container>
          </tr>
          <tr [class.alarm-row]="item.isAlarm">
            <ng-container *ngFor="let value of item.values || []; let j = index">
              @let column = (displayColumns || [])[j];
              @if (j>=3 && column){
              <td class="values-single" >
                <span class="values-single" >{{column | htmlDecode }}</span><br /><br />
                <span class="values-single" [class.value-red]="item.valueColors && item.valueColors[j] == 1">
                  {{ value || '-' | htmlDecode }}</span>
              </td>
              }
            </ng-container>
          </tr>

        </tbody>
      </table>
      <!-- Wallboard Footer -->
      <div class="wallboard-footer" id="wallboardFooter" [style.color]="wallboardData?.settings?.txtColor || '#cbcbcb'"
        [style.font-family]="wallboardData?.settings?.fontFamily || 'Arial, sans-serif'">
        <span class="time-container" *ngIf="showClock">
          <app-clock class="clock"></app-clock>
        </span>
        <span class="footer-info-container">
          <span class="footer-information">{{ wallboardData?.settings?.footerText || '' }}</span>
        </span>
        <span class="logo-container">
          <span class="powered-by">{{ 'realtime:wallboard_Powered' | i18next }}</span>
          <img class="powered-logo" src="assets/Img/Puzzel logo 24 white.svg" alt="Powered by Puzzel" />
        </span>
      </div>
    </div>



  </div>

  <!-- Settings Panel Overlay -->
  <div class="settings-overlay" *ngIf="showSettings" (click)="closeSettings()"></div>

  <!-- Settings Panel -->
  <div class="settings-panel" *ngIf="showSettings" [@slideInFromRight] (click)="$event.stopPropagation()">
    <app-wallboard-settings
      (close)="closeSettings()"
      (settingsSaved)="onSettingsSaved()">
    </app-wallboard-settings>
  </div>
</div>

